import LeadFactsModal from './LeadFactsModal';
export default LeadFactsModal;